import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { useEffectOnce } from '@chilecompra/react-kit'
import { Button, Spinner, Toast, useViewport } from '@chilecompra/react-kit/components'
import { onRecoverAdminThunk } from './RegisterWizard.actions'
import { DesktopNavigation, MobileNavigation, Root, Section } from './RegisterWizardRecoveryCompany.styles'
import { REACT_APP_MERCADO_PUBLICO_BASE_URL } from '../../config/settings/environment'
import { COMMON_ERRORS } from '../../config/settings/constants'

/**
 * The RegisterWizardRecoveryCompany' container.
 */
const RegisterWizardRecoveryCompany = props => {
  const { business, errors, loading } = useSelector(state => state.registerWizard)
  const dispatch = useDispatch()
  const { size } = useViewport()
  const { onChangeStep } = props
  const [retries, setRetries] = useState(0)
  const handleCancel = () => onChangeStep('business-search')
  const handleRetry = () => {
    dispatch(onRecoverAdminThunk({ callback: () => onChangeStep('complete') }))
    setRetries(retries + 1)
  }
  const handleRestart = () => onChangeStep('welcome')
  const handleSignIn = () => window.open(`${REACT_APP_MERCADO_PUBLICO_BASE_URL}/Home/Autenticacion`, '_top')

  useEffectOnce(() => {
    dispatch(onRecoverAdminThunk({ callback: () => onChangeStep('complete') }))
  })

  return (
    <Root>
      {loading && <Spinner />}
      {errors.recoveryError === 'YOU_ARE_ALREADY_ADMIN_ERROR' && !loading && (
        <Toast severity="info">
          Hemos detectado que ya eres administrador de la empresa con RUT {business.dni} en Mercado Público. Puedes
          volver atrás para ingresar un RUT distinto o iniciar sesión en esta empresa
        </Toast>
      )}
      {COMMON_ERRORS.includes(errors.recoveryError) && retries < 4 && !loading && (
        <Toast severity="warning" title="Información temporalmente no disponible">
          <br />
          Lo sentimos, no hemos podido acceder a nuestros registros en este momento, por favor inténtalo nuevamente.
        </Toast>
      )}
      {COMMON_ERRORS.includes(errors.recoveryError) && retries > 3 && !loading && (
        <Toast severity="warning" title="Información temporalmente no disponible">
          <br />
          Lo sentimos, no hemos podido acceder a nuestros registros en este momento. Si este mensaje persiste, por favor
          espera unos minutos e inténtalo nuevamente desde el primer paso
        </Toast>
      )}
      {!size.isTiny && !loading && (
        <Section container margin="52px 0 0" maxWidth="568px">
          <DesktopNavigation>
            <Button onClick={handleCancel} type="button" variant="text" width="100%">
              Atrás
            </Button>
            {errors.recoveryError === 'YOU_ARE_ALREADY_ADMIN_ERROR' && (
              <Button color="primary" margin="0 0 0 30px" type="button" width="100%" onClick={handleSignIn}>
                Ir al inicio de sesión
              </Button>
            )}
            {COMMON_ERRORS.includes(errors.recoveryError) && retries < 4 && (
              <Button
                color="primary"
                variant="outlined"
                margin="0 0 0 30px"
                type="button"
                width="100%"
                onClick={handleRetry}
              >
                Reintentar
              </Button>
            )}
            {COMMON_ERRORS.includes(errors.recoveryError) && retries > 3 && (
              <Button
                color="primary"
                variant="outlined"
                margin="0 0 0 30px"
                type="button"
                width="100%"
                onClick={handleRestart}
              >
                Volver al inicio
              </Button>
            )}
          </DesktopNavigation>
        </Section>
      )}
      {size.isTiny && !loading && (
        <Section container margin="52px 0 0" maxWidth="568px">
          <MobileNavigation>
            <Button onClick={handleCancel} type="button" variant="text" width="168px">
              Atrás
            </Button>
            {errors.recoveryError === 'YOU_ARE_ALREADY_ADMIN_ERROR' && (
              <Button color="primary" margin="0 0 0 30px" type="button" width="100%" onClick={handleSignIn}>
                Ir al inicio de sesión
              </Button>
            )}
            {COMMON_ERRORS.includes(errors.recoveryError) && retries < 4 && (
              <Button
                color="primary"
                variant="outlined"
                margin="0 0 0 30px"
                type="button"
                width="100%"
                onClick={handleRetry}
              >
                Reintentar
              </Button>
            )}
            {COMMON_ERRORS.includes(errors.recoveryError) && retries > 3 && (
              <Button
                color="primary"
                variant="outlined"
                margin="0 0 0 30px"
                type="button"
                width="100%"
                onClick={handleRestart}
              >
                Volver al inicio
              </Button>
            )}
          </MobileNavigation>
        </Section>
      )}
    </Root>
  )
}

RegisterWizardRecoveryCompany.defaultProps = {
  onChangeStep: () => undefined
}

RegisterWizardRecoveryCompany.propTypes = {
  onChangeStep: PropTypes.func
}

export default RegisterWizardRecoveryCompany
